import { assert } from "../../../utils/assert";
import { useApplicationPageAggregatedData } from "./aggregatedData";
import { findByType } from "../../../data";
export function useApplicationPageInitialProps() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useApplicationPageAg = useApplicationPageAggregatedData({
      select: function select(data) {
        var result = findByType(data.included, 'application_page_initial_props');
        assert(result, 'Could not find application_page_initial_props in the response');
        return result.attributes;
      },
      onError: options.onError
    }),
    data = _useApplicationPageAg.data,
    isError = _useApplicationPageAg.isError,
    isFetched = _useApplicationPageAg.isFetched,
    error = _useApplicationPageAg.error;
  return {
    initialProps: data,
    isError: isError,
    isFetched: isFetched,
    error: error
  };
}